import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'immutable';

// Components
import LabelsSearchBar from './components/LabelsSearchBar';
import LabelLists from './components/LabelLists';

import { fetchLabelsByIds, fetchLabelsFromDb } from '../../../../../element/labels/labelsService';
import { reloadLabels } from '../../../../../../common/labels/labelActions';
import useLabelHandlers from './hooks/useLabelHandlers';

// Selectors
import { selectSelectedElementsNormalisedForTaskLists } from '../../../selector/selectionToolsSelector';

// Types
import { LabelsToolContentProps } from './labelComponentPropTypes';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { getLabelsAreStale } from '../../../../../element/labels/labelSelectors';

const LabelsToolContent = (props: LabelsToolContentProps): ReactElement => {
    const { allLabels } = props;

    const dispatch = useDispatch();
    const labelsAreStale = useSelector(getLabelsAreStale);

    useEffect(() => {
        const shouldReloadLabelsOnOpen = labelsAreStale || !allLabels.length;
        if (!shouldReloadLabelsOnOpen) return;

        if (labelsAreStale) {
            fetchLabelsByIds(allLabels.map((label) => label._id)).then((labels) => dispatch(reloadLabels(labels)));
            return;
        }

        fetchLabelsFromDb().then((labels) => dispatch(reloadLabels(labels)));
    }, [allLabels, dispatch, labelsAreStale]);

    const [searchString, setSearchString] = useState<string>('');

    const elements: List<ImMNElement> = useSelector(selectSelectedElementsNormalisedForTaskLists);

    const { handleToggleLabelSelection, handleCreateLabel, handleSearchSubmit } = useLabelHandlers(
        props,
        searchString,
        setSearchString,
        elements,
        allLabels,
    );
    return (
        <div className="LabelsToolContent">
            <LabelsSearchBar value={searchString} onChange={setSearchString} handleSearchSubmit={handleSearchSubmit} />
            <LabelLists
                handleToggleLabelSelection={handleToggleLabelSelection}
                handleCreateLabel={handleCreateLabel}
                elements={elements}
                searchString={searchString}
                allLabels={allLabels}
            />
        </div>
    );
};

export default LabelsToolContent;
